import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { PuzzleGameState } from 'projects/tools/src/lib/store/puzzle-game.state';
import { PuzzleGameModel } from '../../store/puzzle-game.model';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ng2-tooltip-directive-major-angular-updates';

@Component({
  selector: 'lib-app-puzzle-move-counter',
  templateUrl: './puzzle-move-counter.component.html',
  styleUrls: ['./puzzle-move-counter.component.scss'],
  standalone: true,
  imports: [CommonModule, IonText, TranslateModule, TooltipModule],
})
export class PuzzleMoveCounterComponent implements OnInit, OnDestroy {
  moves: Observable<number>;
  moveCounterSubscription: Subscription;
  moveCounter: number;

  constructor(private translate: TranslateService, private store: Store, private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.store
      .select((state) => state.puzzleID)
      .subscribe((puzzleID) => {
        if (puzzleID === '') {
          return;
        }

        if (this.moveCounterSubscription) {
          this.moveCounterSubscription.unsubscribe();
        }

        this.moveCounterSubscription = this.store
          .select(PuzzleGameState.getByID(puzzleID))
          .subscribe((puzzleGame: PuzzleGameModel) => {
            if (!puzzleGame) {
              return;
            }
            this.moveCounter = puzzleGame.moveCounter;
            if (!this.cd[`destroyed`]) {
              this.cd.detectChanges();
            }
          });
      });
  }

  ngOnDestroy(): void {
    if (this.moveCounterSubscription) {
      this.moveCounterSubscription.unsubscribe();
    }
  }
}
